import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { useSidebar } from "../context/SidebarContext";
import styles from "./Layout.module.css";

export default function Layout() {
  const { collapsed } = useSidebar();
  // When collapsed, dashboard takes full width (marginLeft = 0)
  const sideW = collapsed ? "72px" : "256px";

  return (
    <div className={styles.root}>
      <div className={styles.bg} />
      <Sidebar />
      <Topbar />
      <main
        className={`${styles.main} ${collapsed ? styles.mainCollapsed : ""}`}
        style={{ marginLeft: sideW }}
      >
        <Outlet />
      </main>
    </div>
  );
}